import { stdObject } from "../../data/types/stdObject";
import BasicButton from "../BasicButton";
import BasicInput from "../BasicInput";

export default function WriteInput({
  data,
  isTable = false,
}: {
  data: stdObject;
  isTable?: boolean | number;
}) {
  const {
    refId = null,
    inputStyle = {},
    rangeParams = {},
    innerStyle = {},
    active = true,
    ...input
  } = data;

  return isTable ? (
    input.type === "button" ? (
      <tr>
        <td>
          <BasicButton
            onClick={input.onClick ?? (() => {})}
            title={input.label}
            color={input.color}
            style={input.style ?? {}}
          />
        </td>
      </tr>
    ) : (
      <BasicInput
        refId={refId}
        type={(input.type as string) ?? "text"}
        label={(input.label as string) ?? ""}
        value={(input.value as string) ?? ""}
        active={active}
        isTable={isTable}
        innerStyle={innerStyle}
        options={(input.options as Array<any>) ?? []}
        autoFocus={input.autoFocus}
        onFocus={input.onFocus}
        onBlur={input.onBlur}
        onChange={input.onChange}
        placeholder={(input.placeholder as string) ?? ""}
        rangeParams={rangeParams}
        {...(() => {
          const { onChange, ...rest } = input;
          return rest;
        })()}
      />
    )
  ) : (
    <div
      style={{
        width: "100%",
        ...inputStyle,
        display: (input.type as string) === "hidden" ? "none" : "block",
      }}
    >
      {input.type === "button" ? (
        <BasicButton
          onClick={input.onClick ?? (() => {})}
          title={input.label}
          color={input.color}
          style={input.style ?? {}}
        />
      ) : (
        <BasicInput
          refId={refId}
          type={(input.type as string) ?? "text"}
          label={(input.label as string) ?? ""}
          value={(input.value as string) ?? ""}
          active={active}
          isTable={isTable}
          innerStyle={innerStyle}
          options={(input.options as Array<any>) ?? []}
          autoFocus={input.autoFocus}
          onFocus={input.onFocus}
          onBlur={input.onBlur}
          onChange={input.onChange}
          placeholder={(input.placeholder as string) ?? ""}
          rangeParams={rangeParams}
          {...(() => {
            const { onChange, ...rest } = input;
            return rest;
          })()}
        />
      )}
    </div>
  );
}
